import React from 'react';
import { Button, Drawer, Menu } from '@mantine/core';
import Icons from 'components/ui/Icons';
import { Icon } from '@iconify/react';
import { OrderFragment } from 'state/gql/_types';
import { CreateExtensionDrawer } from 'components/tenant/extensions/actions/CreateExtensionAction';

export type MenuOption = {
    label: string;
    component: React.FC<{ label: string }>;
}

const TenantOrderMenu: React.FC<{ currentItem: OrderFragment }> = ({ currentItem }) => {

    const [opened, setOpened] = React.useState(false);

    return (
        <React.Fragment>
            <Menu
                closeOnItemClick
                withArrow
                trapFocus={false}
                control={
                    <Button px={8} variant="outline" color="gray">
                        <Icon icon={Icons.settings} width={20} />
                    </Button>
                }
                sx={{
                    display: 'flex'
                }}
            >

                <Menu.Label>Modify Order</Menu.Label>

                {(currentItem.status === 'open' || currentItem.status === 'completed') && (
                    <Menu.Item onClick={() => setOpened(true)}>
                        Create Extension
                    </Menu.Item>
                )}

            </Menu>
            <Drawer
                position="right"
                opened={opened}
                onClose={() => setOpened(false)}
                title="Create Extension"
                padding={0}
                size="xl"
                styles={(theme) => ({
                    header: {
                        borderBottom: `1px solid ${theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[5]}`,
                        marginBottom: 0,
                        padding: theme.spacing.xl
                    },
                    drawer: {
                        height: '100%',
                        minHeight: '100%',
                        maxHeight: '100%',
                    },
                })}
            >
                <CreateExtensionDrawer onClose={() => setOpened(false)} />
            </Drawer>
        </React.Fragment>

    )
}

export default TenantOrderMenu;